/**
 * Product page add-ons — wires up the Liquid-rendered DOM.
 *
 * The addons markup is rendered server-side by Liquid from
 * `product.metafields.addons.config` (per-product) with fallback to
 * `shop.metafields.addons.type_rules[product.type]`. This file:
 *   1. Toggles checked state + subtotal as boxes are checked.
 *   2. Wires the "Add All to Cart" button to include checked addons.
 *   3. Exposes `window.getCheckedAddons()` so the main ATC can include them.
 */
(function () {
  'use strict';

  var variantChangeHandler = null;

  function getMainProductPrice() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return 0;
    var productData = form.getAttribute('data-product');
    if (!productData) return 0;
    try {
      var product = JSON.parse(productData);
      var selectedInput = form.querySelector('[name="id"]');
      var selectedId = selectedInput ? Number(selectedInput.value) : null;
      if (selectedId && product.variants) {
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === selectedId) return product.variants[i].price;
        }
      }
      return product.price || 0;
    } catch (e) {
      return 0;
    }
  }

  function getSelectedVariantId() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    return input ? Number(input.value) : null;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateSubtotal(container) {
    var subtotalEl = container.querySelector('.product-addons__subtotal-amount');
    var footer = container.querySelector('.product-addons__footer');
    if (!subtotalEl || !footer) return;
    var mainPrice = getMainProductPrice();
    var addonTotal = 0;
    var hasChecked = false;
    container.querySelectorAll('.product-addons__checkbox:checked').forEach(function (cb) {
      addonTotal += Number(cb.dataset.price) || 0;
      hasChecked = true;
    });
    footer.style.display = hasChecked ? '' : 'none';
    subtotalEl.textContent = formatMoney(mainPrice + addonTotal);
  }

  // Exposed so a custom main-product ATC handler can include addons.
  window.getCheckedAddons = function () {
    var el = document.getElementById('product-addons');
    if (!el) return [];
    var addons = [];
    el.querySelectorAll('.product-addons__checkbox:checked').forEach(function (cb) {
      addons.push({ id: Number(cb.dataset.variantId), quantity: 1, properties: { _source: 'addon' } });
    });
    return addons;
  };

  function wireServerRenderedAddons(container) {
    updateSubtotal(container);

    container.querySelectorAll('.product-addons__checkbox').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var card = cb.closest('.product-addons__card');
        if (cb.checked) {
          card.classList.add('product-addons__card--checked');
        } else {
          card.classList.remove('product-addons__card--checked');
        }
        updateSubtotal(container);
      });
    });

    if (variantChangeHandler) {
      document.removeEventListener('change', variantChangeHandler);
    }
    variantChangeHandler = function (e) {
      if (e.target && e.target.name === 'id') {
        setTimeout(function () { updateSubtotal(container); }, 50);
      }
    };
    document.addEventListener('change', variantChangeHandler);

    container.querySelector('.product-addons__atc-btn').addEventListener('click', function () {
      var btn = this;
      var variantId = getSelectedVariantId();
      if (!variantId) return;

      var items = [{ id: variantId, quantity: 1 }];
      var addons = window.getCheckedAddons ? window.getCheckedAddons() : [];
      items = items.concat(addons);

      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('disabled');
      btn.querySelector('.text').textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.querySelector('.text').textContent = 'Added!';
          setTimeout(function () {
            btn.removeAttribute('disabled');
            btn.classList.remove('disabled');
            btn.querySelector('.text').textContent = 'Add All to Cart';
          }, 1200);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success: function (cart) {
              setTimeout(function () {
                if (typeof window.refreshCart === 'function') window.refreshCart(cart);
                $('.cart-container').addClass('active');
                $('body').removeClass('overlay-removed').addClass('locked');
                if (window.PXUTheme && window.PXUTheme.media_queries && window.PXUTheme.media_queries.medium.matches) {
                  $('body').addClass('blocked-scroll');
                }
              }, 500);
            }
          });
        })
        .catch(function () {
          btn.removeAttribute('disabled');
          btn.classList.remove('disabled');
          btn.querySelector('.text').textContent = 'Add All to Cart';
        });
    });
  }

  function initProductAddons() {
    var container = document.getElementById('product-addons');
    if (!container) return;

    var src = container.getAttribute('data-source');
    if (src === 'liquid-config' || src === 'metafield') {
      wireServerRenderedAddons(container);
    } else {
      container.style.display = 'none';
    }
  }

  window.initProductAddons = initProductAddons;

  initProductAddons();
})();
